import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class EntityChartMapService {
  constructor(private http: HttpClient) {}

  loadJsonObject(baseUrl: string, params: any): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<any>(`${baseUrl}/loadJsonObject`, {
      params: httpParams,
      withCredentials: true,
    });
  }

  saveEntityChartMap(
    baseUrl: string,
    returnObj: any,
    payload: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const actionCode = returnObj?.save_type === 'taxCode' ? 'p9xu04' : 'h1rkx6';
    const url = `${baseUrl}/saveJsonObject?action_code=${actionCode}`;

    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams || {});
    params = _.extend({ jsonObj: JSON.stringify(payload || []) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(returnObj || {}) }, params);
    params.process_name = 'ENTITY_CHART_MAP_SAVE';
    params.tax_year = rowData?.TAX_YEAR || filterParams?.tax_year || params.tax_year;
    params.scenario = rowData?.SCENARIO || filterParams?.scenario || params.scenario;
    params.jcd_key = rowData?.JCD_KEY || filterParams?.jcd_key || params.jcd_key;

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, String(value));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  updateEntityChartDetails(baseUrl: string, data: any[], userSettings: any, rowData: any): Observable<any> {
    const url = `${baseUrl}/updateEntityChartDetails`;
    const params = {
      ssoId: userSettings?.user?.sso_id || '',
      tax_year: rowData?.TAX_YEAR || '',
      json_string: JSON.stringify(data || []),
    };

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = (params as any)[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, String(value));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
